import MainStore from '../stores/MainStore.js';
import * as Cart from './Cart.js';
import * as Products from './Products.js';


export const _adjustUpsellProducts = () => {
  //console.log(window.__config_reactjs_cart.free_item_auto_add);

  /*
  if( window.__config_reactjs_cart.free_item_auto_add ){
    if( !tryToAddFreeBundler() ){
      MainStore._cartChange();
    }
    else MainStore._cartChange();
  }
  else{
    if( !tryToRemoveFreeBundler() ){
      MainStore._cartChange();
    }
    else MainStore._cartChange();
  }
  */

  if( window.__config_reactjs_cart.free_item_auto_add ){
    tryToAddFreeBundler();
  }
  else{
    tryToRemoveFreeBundler();
  }

  tryToRemoveWildHoneySampleBundler();

  MainStore._cartChange();
  
}

export const tryToRemoveWildHoneySampleBundler = () =>{
	let wild_honey_sample = false;
	let item_wild_honey = null;
  let warmer = false;

  if( MainStore.cart===null || typeof MainStore.cart === "undefined" ) return;

  for(let key in MainStore.cart.items ){
    let item = MainStore.cart.items[key];

    if( item.handle === window.__config_reactjs_cart.upsell_item_wild_honey_sample_handle ){
    	wild_honey_sample = true;
    	item_wild_honey = item;
    	continue;
    }

    let product = Products.getProductByVariantID(item.variant_id);
    //console.log(product);
    if( product===null ) continue;
    if( product.tags.includes('wax warmers') ) warmer = true;
    //console.log(item.handle);
    
  }

  //warmer = false;
  if( !warmer && wild_honey_sample ){
  	Cart._productRemove(item_wild_honey);
  }
  //console.log( wild_honey_sample );
  //console.log( warmer );
}

export const tryToRemoveFreeBundler = () =>{
  //Ignore free retail item
  //if( !window.__config_reactjs_cart.free_item_auto_add ) return false;
  if( MainStore.try_add_free_item_fails>1 ) return false;
  if( MainStore.cart===null || typeof MainStore.cart === "undefined" ) return false;

  let retail_bundle_found = false;
  let item_bundle = null;
  for(let key in MainStore.cart.items ){
    let item = MainStore.cart.items[key];
    if( item.handle === window.__config_reactjs_cart.free_item_handle ){
      retail_bundle_found = true;
      item_bundle = item;
      break;
    }
  }


  if( retail_bundle_found ){
    MainStore.try_add_free_item_fails++;
    Cart._productRemove(item_bundle);
    return true;
  }

  return false;
}

export const tryToAddFreeBundler = () =>{
  //Ignore free retail item
  if( !window.__config_reactjs_cart.free_item_auto_add ) return false;
  if( MainStore.try_add_free_item_fails>1 ) return false;

  let retail_bundle_found = false;
  let item_bundle = null;
  for(let key in MainStore.cart.items ){
    let item = MainStore.cart.items[key];
    if( item.handle === window.__config_reactjs_cart.free_item_handle ){
      retail_bundle_found = true;
      item_bundle = item;
      break;
    }
  }

  if( MainStore.cart.total_price>=window.__config_reactjs_cart.free_item_boundary && !retail_bundle_found ){
    //Add retail bundle product
    MainStore.try_add_free_item_fails++;
    Cart._productAdd(window.__config_reactjs_cart.free_item_variant_id,1);
    return true;
  }
  else if( MainStore.cart.total_price<window.__config_reactjs_cart.free_item_boundary && retail_bundle_found ){
    MainStore.try_add_free_item_fails++;
    Cart._productRemove(item_bundle);
    return true;
  }

  return false;
}